<template>
  <hr-card class="HRFieldLinkButton">
    <div class="HRFieldLinkButton__title">
      {{ title }}
    </div>
    <div class="HRFieldLinkButton__cta">
      <co-button class="HRFieldLinkButton__button" @click="executeCta">{{
        cta
      }}</co-button>
    </div>
    <div class="HRFieldLinkButton__helper">
      {{ helper }}
    </div>
  </hr-card>
</template>

<script>
import { CoButton } from '@deputy/copilot2';
import HrCard from './hr-card';
export default {
  name: 'hrfield-link-button',
  components: { CoButton, HrCard },
  props: {
    icon: { type: String, default: null },
    title: { type: String, default: null },
    helper: { type: String, default: null },
    cta: { type: String, default: null },
    url: { type: String, default: null },
  },
  setup(props) {
    function executeCta() {
      if (props.url) {
        window.open(props.url, '_blank');
      }
    }
    return {
      executeCta,
    };
  },
};
</script>

<style lang="scss">
@import '@/core/style-vars.scss';

.HRFieldLinkButton .DSCard-container {
  border: none;
  border-radius: 8px;
  background: var(--co-background-secondary);
}

.HRFieldLinkButton .DSCard__body {
  padding: 30px;
}

.HRFieldLinkButton__cta {
  text-align: center;
}

.HRFieldLinkButton__helper {
  color: var(--co-text-primary);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin-top: 30px;
}

.HRFieldLinkButton__title {
  padding: 25px 8px;
  font-size: 16px;
  color: var(--co-text-primary);
  font-weight: bold;
  text-align: center;
  width: 100%;
}
.HRFieldLinkButton__button {
  font-size: 14px !important;
}
</style>
